<template>
	<div class="login d-flex">
		<div class="login-block-left d-flex align-items-center justify-content-center">
			<div class="d-flex align-items-center">
				<img src="@/assets/images/login/logo-dashboard.svg" class="desktop-logo" alt />
				<p class="text-introduction">A Product Of FireApps</p>
			</div>
		</div>
		<div class="login-block-right d-flex align-items-center flex-column justify-content-center">
			<div class="wrapper-form-login d-flex flex-column align-items-center">
				<h2 class="custom-text-welcome">Welcome</h2>
				<p class="enter-text-url">Please enter your Shopify URL</p>
				<div class="login-form-information d-flex flex-column align-items-center m-t-40">
					<form class="card-form" @submit.stop.prevent="onSubmit()">
						<div class="card-form-input" >
							<div class="card-form-input-wrap" >
								<input type="text" name="shopname" autocomplete="on" :class="{'is-invalid': formstate && $v.form.shop.$invalid}" class="form-control custom-login-name" placeholder="Store Name" v-model.trim="form.shop" />
								<span class="custom-after-name">.myshopify.com</span>
							</div>
							<transition name="fade" mode="out-in">
								<div class="card-form-error" v-if="(formstate && $v.form.shop.$invalid) || regrexName">
									Please enter your Store Name
								</div>
							</transition>
						</div>
						<button type="submit" class="btn btn-primary custom-btn-login" :class="{ 'is-loading' : is_loading}">Log In</button>
					</form>
					<p class="m-t-20">
						Don’t have a
						<span>
							<img src="@/assets/images/login/icon-shopify.svg" alt />
						</span>
						<strong>Shopify store</strong> yet?
						<a href="https://shopify.pxf.io/5bqe3N" target="_blank">Create store</a>
					</p>
				</div>
			</div>
			<div class="d-flex block-service">
				<div class="terms">
					<a target="_blank" href="https://fireapps.io/terms-of-service">Terms of Service</a>
				</div>
				<div class="privacy">
					<a target="_blank" href="https://fireapps.io/privacy-policy">Privacy Policy</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import {mapActions} from "vuex";
import LineBase from '@/plugins/linebase.js'
export default {
	name: "Login",
	metaInfo(){
		return {
			title: 'Installation | Sales Box',
		}
	},
	data() {
		return {
			is_loading :false,
			formstate : false,
			form: {
				shop: ""
			},
			regrexName: false,
		};
	},
	methods: {
		...mapActions({
			install: "auth/install"
		}),
		onSubmit(e) {
			this.formstate = true
			this.form.shop = this.form.shop.replace(/.myshopify.com/gi, "");
			const regex = /[!@#$%^&*(),.?":{}|<>`']/gi;
			this.regrexName = regex.test(this.form.shop);

			if( !this.is_loading && !this.$v.form.$invalid && !this.regrexName){
				this.is_loading = true 
				this.install(this.form).then((res)=>{
					let { status , data } = res.data
					if( status ){
						window.location.href = data 
					}
				})
				.catch((res)=>{

				})
				.finally(()=>{
					this.is_loading = false
				})
			}
		}
	},
	created(){
		new LineBase({
				guest_id : this.$helper.createId()
		})
	},
	validations(){
		return {
			form : {
				shop : {
					required 
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.border-red {
	border: 1px solid $red;
	border-radius: 4px;
	box-shadow: inset 0 0 0 0 transparent, 0 0 0 0.1rem $red;
	outline: none;

	.form-control {
		&:focus {
			box-shadow: none;
			outline: none;
		}
	}
}

.login {
	width: 100%;

	h1 {
		&.custom-text-box {
			font-weight: bold;
			margin-left: 20px;
			color: $app-bg;
		}
	}

	.text-introduction {
		position: absolute;
		bottom: 34px;
		left: 389px;
		font-size: 18px;
		color: white;
	}

	h2 {
		&.custom-text-welcome {
			font-weight: 800;
			text-transform: uppercase;
			font-size: 35px;
			color: #3dba50;
		}
	}

	&-block-left {
		width: 50%;
		height: 100vh;
		background-image: url("../../assets/images/login/login-background.svg");
		background-size: cover;
		background-position: bottom center;
		background-repeat: no-repeat;
	}

	&-block-right {
		width: 50%;
		height: 100vh;
		position: relative;

		.enter-text-url {
			color: #777683;
			font-size: 15px;
		}

		.wrapper-form-login {
			.login-form-information {
				width: 360px;

				.custom-input-prepend {
					width: 360px;
					height: 48px;
					font-size: 15px;
				}
				.card-form{
					display: block;
					width: 100%;
					position: relative;
					&-input{
						margin-bottom: 24px;
						position: relative;
						&-wrap{
							position: relative;
							.custom-login-name {
								font-size: 15px;
								height: 48px;
								padding-right: 135px;
								padding-left: 15px
							}
							.custom-after-name {
								font-size: 15px;
								font-style: normal;
								font-weight: normal;
								pointer-events: none;
								position: absolute;
								top: 1px;
								right: 1px;
								background: transparent;
								height: 46px;
								width: 130px;
								display: flex;
								align-items: center;
								color: #242539;
								opacity: 0.5;
							}
						}
					}
					&-error{
						position: absolute;
						top: 100%;
						left: 0;
						right: 0;
						color:$danger;
						font-size: 13px;
						font-weight: 600;
					}
				}
				

				

				.custom-btn-login {
					height: 48px;
					font-weight: bold;
					font-size: 18px;
					width: 100%;
				}
			}
		}

		.block-service {
			position: absolute;
			bottom: 50px;

			.terms {
				position: relative;
				padding: 0 40px;
				margin-right: 40px;

				a {
					color: $sb-text-active;
				}

				&::after {
					content: "";
					width: 1px;
					height: 21px;
					background: #000;
					position: absolute;
					right: 0;
				}
			}

			.privacy {
				a {
					color: $sb-text-active;
				}
			}
		}
	}
}
</style>